/**
 * This is an entrypoint for your main javascript file, when you run gulp watch this file and all
 * it's imports will get bundled into a minified js file and saved in the assets/bundle folder
 *
 * Info about importing modules https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
 */

import LazyLoad from "vanilla-lazyload";
import { Product } from "./Product";
import feather from "feather-icons";
import Glide from "@glidejs/glide";
import { TeamMember } from "./TeamMember";

/**
 * This function will lazyload every image with the class .lazy
 * info: https://github.com/verlok/lazyload
 */
var lazyLoadInstance = new LazyLoad({
  elements_selector: ".lazy",
  class_loaded: "lazy-loaded"
});

feather.replace();

// Init product class
if (document.querySelector(".product-single") !== null) {
  var product = new Product();

  window.addEventListener("load", e => {
    if (window.innerWidth < 768) {
      var node = document.querySelector(".product-single__files");
      node.remove();
      document.querySelector(".product-single__content").appendChild(node);
    }
  });

  window.addEventListener("resize", e => {
    if (window.innerWidth < 768) {
      var node = document.querySelector(
        ".product-single__scrollable .product-single__files"
      );
      if (node) {
        node.remove();
        document.querySelector(".product-single__content").appendChild(node);
      }
    } else {
      var node = document.querySelector(
        ".product-single__content .product-single__files"
      );
      if (node) {
        node.remove();
        document.querySelector(".product-single__scrollable").appendChild(node);
      }
    }
  });
}

// Animate scrollbar
var prevScrollDistance = window.scrollY;

navbarOnScroll();
document.addEventListener("scroll", e => navbarOnScroll(e));

function navbarOnScroll(e) {
  var scrollDistance = window.scrollY;
  var navbar = document.querySelector(".navbar");

  if (document.body.classList.contains("nav-active")) return;

  if (scrollDistance > 64) {
    navbar.classList.add("scrolled");
  } else {
    navbar.classList.remove("scrolled");
  }

  if (prevScrollDistance < scrollDistance && scrollDistance > 400) {
    navbar.classList.add("hidden");
  } else {
    navbar.classList.remove("hidden");
  }

  prevScrollDistance = scrollDistance;
}

var openModal = document.querySelector(".modal.open");
if (openModal) {
  document.body.classList.toggle("modal-open");
}

document.querySelectorAll("[data-modal-toggle]").forEach(el => {
  var modal = document.getElementById(el.dataset.modalToggle);

  el.addEventListener("click", e => {
    document.body.classList.toggle("modal-open");
    modal.classList.toggle("open");

    var event = new CustomEvent("modal-toggled", { detail: el });
    document.dispatchEvent(event);
  });
});

var isHome = document.querySelector(".glide--home") == null ? false : true;

if (isHome) {
  var glideInstanceHome = new Glide(".glide--home", {
    swipeThreshold: 20,
    type: "slider",
    gap: 0
    // autoplay: 4000,
  });

  glideInstanceHome.mount();

  var navButton = document.querySelector(".navbar-nav .cta a");

  glideInstanceHome.on("run.after", () => {
    setSlideColor();
    setArrowNumbers();
  });

  function setArrowNumbers() {
    var slides = document.querySelectorAll(".glide--home .glide__slide");
    var active;

    slides.forEach((el, index) => {
      if (el.classList.contains("glide__slide--active")) {
        active = index;
      }
    });

    var right = document.querySelector(".glide--home .glide__arrow--right");
    var left = document.querySelector(".glide--home .glide__arrow--left");

    right.querySelector(".current").innerHTML = active + 1;
    left.querySelector(".current").innerHTML =
      active == 0 ? slides.length : active;
  }

  function setSlideColor() {
    var active = document.querySelector(".glide--home .glide__slide--active");

    var color = active.dataset.color;

    navButton.setAttribute(
      `style`,
      `background-color: ${color}; border-color: ${color}`
    );
  }

  setSlideColor();

  var glideInstanceNews = new Glide(".glide--news", {
    swipeThreshold: 20,
    type: "slider",
    perView: 4,
    gap: 30,
    bound: true,
    breakpoints: {
      1461: {
        perView: 3
      },
      1140: {
        perView: 2
      },
      540: {
        gap: 15,
        perView: 1.3
      }
    }
  });

  glideInstanceNews.mount();

  var glideInstanceLogos = new Glide(".glide--logos", {
    swipeThreshold: 20,
    type: "carousel",
    perView: 7,
    gap: 30,
    autoplay: 2000,
    breakpoints: {
      991: {
        perView: 4
      },
      367: {
        perView: 3
      }
    }
  });

  glideInstanceLogos.mount();
}

document.querySelectorAll(".team__item").forEach(el => {
  new TeamMember(el);
});

document.querySelectorAll("[data-action]").forEach(el => {
  var action = el.dataset.action;

  el.addEventListener("click", e => {
    e.preventDefault();

    if (action == "toggle-nav") {
      document.body.classList.toggle("nav-active");
    }
  });
});

document.querySelectorAll(".menu-item-has-children").forEach(el => {
  el.addEventListener("click", e => {
    e.stopPropagation();

    var isActive = el.classList.contains("active");
    el.classList.toggle("active");

    if (isActive) {
      el.setAttribute(`style`, `max-height: 46px`);
    } else {
      var height = el.querySelector(".dropdown-menu").getBoundingClientRect()
        .height;
      el.setAttribute(`style`, `max-height: ${46 + height}px`);
    }
  });
});
